export default __webpack_public_path__ + "static/media/336.1b0488d8.gif";